import { workstreamTypes, workstreamStatus } from './types';
import { startOfMonth, differenceInDays } from 'date-fns';

export const parseDate = (dateString: string | Date): Date => {
  if (dateString instanceof Date) return dateString;
  try {
    const date = new Date(dateString);
    return isNaN(date.getTime()) ? new Date() : date;
  } catch {
    return new Date();
  }
};

export const getWorkstreamPosition = (startDate: string | Date, endDate: string | Date, today: Date) => {
  const timelineStart = startOfMonth(today);
  const monthWidth = 100; // pixels per month
  const daysPerMonth = 30;
  
  const start = parseDate(startDate);
  const end = parseDate(endDate);

  console.log('Position Calculation Details:', {
    timelineStart,
    start,
    end,
    monthWidth,
    daysPerMonth
  });

  const startOffset = differenceInDays(start, timelineStart);
  const duration = differenceInDays(end, start);

  const left = (startOffset / daysPerMonth) * monthWidth;
  const width = (duration / daysPerMonth) * monthWidth;

  console.log('Position Results:', {
    startOffset,
    duration,
    left,
    width
  });

  return { 
    left: Math.max(0, left),
    width: Math.max(50, width)
  };
};

export const getDefaultType = (type: string) => {
  return workstreamTypes[type as keyof typeof workstreamTypes] || workstreamTypes.FEATURE;
};

export const getDefaultStatus = (status: string) => {
  return workstreamStatus[status as keyof typeof workstreamStatus] || workstreamStatus.PLANNED;
};

export const getMilestonePosition = (date: string | Date, today: Date) => {
  const timelineStart = startOfMonth(today);
  const monthWidth = 100; // pixels per month
  const daysPerMonth = 30;
  
  const milestoneDate = parseDate(date);
  const dayOffset = differenceInDays(milestoneDate, timelineStart);
  
  return Math.max(0, (dayOffset / daysPerMonth) * monthWidth);
};